// video-modal.js
class VideoModal {
    constructor(options = {}) {
        this.videoId = options.videoId;
        this.modalId = options.modalId || 'videoModal';
        this.triggerId = options.triggerId;
        this.title = options.title || 'Video';
        this.autoplay = options.autoplay !== false; // default true

        this.init();
    }

    init() {
        if (!this.videoId) {
            console.error('VideoModal: videoId is required');
            return;
        }

        this.createModal();
        this.setupEventListeners();
    }

    createModal() {
        // Check if modal already exists
        if (document.getElementById(this.modalId)) {
            this.videoModal = document.getElementById(this.modalId);
            this.videoFrame = this.videoModal.querySelector('iframe');
            return;
        }

        // Create modal HTML
        const modalHTML = `
            <div class="modal fade" id="${this.modalId}" tabindex="-1" role="dialog" aria-labelledby="${this.modalId}Label" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered modal-video-custom" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="${this.modalId}Label">${this.title}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body p-0">
                            <div class="embed-responsive embed-responsive-16by9">
                                <iframe class="embed-responsive-item"
                                        src=""
                                        title="YouTube video player"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowfullscreen>
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        // Append to body
        document.body.insertAdjacentHTML('beforeend', modalHTML);

        // Get references
        this.videoModal = document.getElementById(this.modalId);
        this.videoFrame = this.videoModal.querySelector('iframe');
    }

    setupEventListeners() {
        if (!this.videoModal) return;

        // Bootstrap modal events
        this.videoModal.addEventListener('shown.bs.modal', () => {
            this.loadVideo();
        });

        this.videoModal.addEventListener('hidden.bs.modal', () => {
            this.stopVideo();
        });

        // Generic events as fallback
        this.videoModal.addEventListener('show', () => {
            this.loadVideo();
        });

        this.videoModal.addEventListener('hide', () => {
            this.stopVideo();
        });

        // Setup trigger if provided
        if (this.triggerId) {
            this.setupTrigger();
        }
    }

    setupTrigger() {
        const trigger = document.getElementById(this.triggerId);
        if (!trigger) return;

        // Set data attributes for Bootstrap
        trigger.setAttribute('data-toggle', 'modal');
        trigger.setAttribute('data-target', `#${this.modalId}`);
        trigger.style.cursor = 'pointer';

        // Click handler with fallbacks
        trigger.addEventListener('click', () => {
            setTimeout(() => {
                this.loadVideo();
            }, 300);

            // MutationObserver fallback
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                        if (this.videoModal.style.display === 'block' || this.videoModal.classList.contains('show')) {
                            this.loadVideo();
                            observer.disconnect();
                        }
                    }
                });
            });

            observer.observe(this.videoModal, {
                attributes: true,
                attributeFilter: ['style', 'class']
            });
        });
    }

    buildVideoUrl() {
        const baseUrl = 'https://www.youtube.com/embed/';
        const params = new URLSearchParams();

        if (this.autoplay) {
            params.append('autoplay', '1');
        }

        const paramString = params.toString();
        return `${baseUrl}${this.videoId}${paramString ? '?' + paramString : ''}`;
    }

    loadVideo() {
        if (this.videoFrame) {
            this.videoFrame.src = this.buildVideoUrl();
        }
    }

    stopVideo() {
        if (this.videoFrame) {
            this.videoFrame.src = '';
        }
    }

    // Public methods
    show() {
        if (typeof $ !== 'undefined') {
            $(this.videoModal).modal('show');
        } else {
            // Manual fallback
            this.videoModal.style.display = 'block';
            this.videoModal.classList.add('show');
            document.body.classList.add('modal-open');
            this.loadVideo();
        }
    }

    hide() {
        if (typeof $ !== 'undefined') {
            $(this.videoModal).modal('hide');
        } else {
            // Manual fallback
            this.videoModal.style.display = 'none';
            this.videoModal.classList.remove('show');
            document.body.classList.remove('modal-open');
            this.stopVideo();
        }
    }
}

// Utility function for easy initialization
window.initVideoModal = function(options) {
    return new VideoModal(options);
};


// Store references to YouTube iframes that are currently playing
let activeYouTubeIframes = [];

// Track YouTube iframes when modals show
$(document).on('shown.bs.modal', '.modal', function() {
    const modal = $(this);
    modal.find('iframe').each(function() {
        const src = this.src;
        if (src && (src.includes('youtube.com') || src.includes('youtu.be'))) {
            activeYouTubeIframes.push(this);
        }
    });
});

// Clear tracking when modal hides normally
$(document).on('hidden.bs.modal', '.modal', function() {
    activeYouTubeIframes = [];
});

// ESC key handler - use stored references
$(document).on('keydown', function(e) {
    if (e.keyCode === 27) { // ESC key
        console.log('ESC pressed, stopping stored YouTube iframes:', activeYouTubeIframes.length);

        // Stop all tracked YouTube iframes
        activeYouTubeIframes.forEach(function(iframe) {
            if (iframe && iframe.parentNode) {
                console.log('Stopping YouTube iframe:', iframe.src);
                iframe.src = '';
                iframe.src = 'about:blank';
            }
        });

        // Clear the array
        activeYouTubeIframes = [];
    }
});

// Existing handlers for click and backdrop
$(document).on('click', '[data-dismiss="modal"]', function() {
    const modal = $(this).closest('.modal');
    modal.find('iframe').each(function() {
        const src = this.src;
        if (src.includes('youtube.com') || src.includes('youtu.be')) {
            this.src = '';
            this.src = 'about:blank';
        }
    });
});

$(document).on('click', '.modal', function(e) {
    if (e.target === this) { // backdrop click
        $(this).find('iframe').each(function() {
            const src = this.src;
            if (src.includes('youtube.com') || src.includes('youtu.be')) {
                this.src = '';
                this.src = 'about:blank';
            }
        });
    }
});
